import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-table-text-filters',
  templateUrl: './table-text-filters.component.html',
  styleUrls: ['./table-text-filters.component.scss']
})
export class TableTextFiltersComponent implements OnInit {

  constructor() { }

  @Input() pills: Array<string> = [];
  @Output() deleteTextFilters = new EventEmitter<string>();

  ngOnInit(): void {
  }

  deletePill(pill) {
    this.deleteTextFilters.emit(pill);
  }

}
